/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BodyInputs */

const en_body = /** @type {(inputs: BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body`)
};

const es_body = /** @type {(inputs: BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuerpo`)
};

/**
* | output |
* | --- |
* | "Body" |
*
* @param {BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const body = /** @type {((inputs?: BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_body(inputs)
	return es_body(inputs)
});